import { render } from "./DraftPressRelease.vue?vue&type=template&id=18154ada"
import script from "./DraftPressRelease.vue?vue&type=script&lang=js"
export * from "./DraftPressRelease.vue?vue&type=script&lang=js"

import "./DraftPressRelease.vue?vue&type=style&index=0&id=18154ada&lang=less"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__